import FormService from "../../services/FormService";
import FormInput from '../../components/FormInput';
import SelectPicker from '../../components/SelectPicker';


export default {
	components: {
		FormInput,
		SelectPicker,
	},
	data(){
		return {
			form: new FormService({
				name: null,
				price: null,
				status: null,
				is_required: false,
                is_reportable: false,
                is_international: false,
			}),

			modelList: [],
			modelStatus: [
                {
                    "code": 10,
                    "name": "Активный",
                },
                {
					"code": 5,
					"name": "Выключено",
				},
			],
			status: 0,
		}
	},
	methods: {
		Create() {
			this.form.post('services.create')
				.then(res => {
					if (!res.errors) {
						$('#exampleModal').modal('hide');
						this.GetAll();
						this.$store.commit('successNotify');
					}
				});
		},
		Read(id) {
			this.$api.get('services.show', id)
				.then(res => {
					// console.log(res);
					this.form.setData(res.data);
					$('#exampleModal').modal('show');
				});
		},
		Update() {
			this.form.put('services.update', this.form.id)
				.then(res => {
					if (!res.errors) {
						$('#exampleModal').modal('hide');
						this.GetAll();
						this.$store.commit('successNotify');
					}
				});
		},
		Delete(id) {
			if (confirm(this.i18n('You are about to delete the record!\nAre you sure?'))) {
				this.$api.delete('services.delete', id)
					.then(res => {
						if (!res.errors) {
							this.GetAll();
							this.$store.commit('successNotify');
						}
					});
			}
		},
		GetAll() {
			this.$api.get('services.index')
				.then(res => {
					// console.log(res);
					this.modelList = res.data;
				});
		},
	},
	mounted() {
		this.GetAll();


		$('#exampleModal').on('hidden.bs.modal', (e) => {
			this.form.reset();
			this.form.is_required = false;
			this.form.is_reportable = false;
            this.form.is_international = false;
		})
	}
}
